import { Card, InformationalLegends } from '@wyz/ui';
import * as React from 'react';
import { Trans } from '~/common/context';
import type { IContainerOrder } from '~/common/types';

interface OrderDetailsCardProps {
  order: Pick<
    IContainerOrder,
    'supplier' | 'containerType' | 'orderer' | 'customer'
  >;
  display?: {
    customer?: boolean;
    supplier?: boolean;
    containerType?: boolean;
    orderer?: boolean;
  };
}

const OrderDetailsCard: React.FC<OrderDetailsCardProps> = ({
  order,
  display = {
    customer: false,
    containerType: true,
    orderer: true,
    supplier: true,
  },
}) => {
  return (
    <Card className='h-100'>
      <Card.Body className='space-y-2'>
        <InformationalLegends.Container>
          {display.customer && (
            <InformationalLegends.Row>
              <InformationalLegends.Label>
                <Trans i18nKey='app.quote.history.table.client' />
              </InformationalLegends.Label>
              <InformationalLegends.Value id='source'>
                {order.customer.name}
              </InformationalLegends.Value>
            </InformationalLegends.Row>
          )}
          {display.supplier && (
            <InformationalLegends.Row>
              <InformationalLegends.Label>
                <Trans i18nKey='app.purchase.cart_page.table.source' />
              </InformationalLegends.Label>
              <InformationalLegends.Value id='source'>
                {order.supplier.name}
              </InformationalLegends.Value>
            </InformationalLegends.Row>
          )}
          {display.containerType && (
            <InformationalLegends.Row>
              <InformationalLegends.Label>
                <Trans i18nKey='app.container.pricing_policy.form.container_type' />
              </InformationalLegends.Label>
              <InformationalLegends.Value id='container-type'>
                {order.containerType}
              </InformationalLegends.Value>
            </InformationalLegends.Row>
          )}
          {display.orderer && (
            <InformationalLegends.Row>
              <InformationalLegends.Label>
                <Trans i18nKey='app.common.user' />
              </InformationalLegends.Label>
              <InformationalLegends.Value id='user'>
                {order.orderer.name}
              </InformationalLegends.Value>
            </InformationalLegends.Row>
          )}
        </InformationalLegends.Container>
      </Card.Body>
    </Card>
  );
};

export default OrderDetailsCard;
